import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Select,
  Table,
  Spin,
  Card,
  message,
  Button,
  Input,
} from "antd";
import dataService from "../networks/api/service/dataService";
import { useNavigate } from "react-router-dom";
import CustomTable from "./TableComponent/CustomTable";

const { Option } = Select;

function BriefDetails({
  title,
  primaryDropdownLabel,
  primaryDropdownData,
  primaryDropdownValue,
  onPrimarySelect,
  secondaryDropdownLabel,
  secondaryDropdownData,
  secondaryDropdownValue,
  onSecondarySelect,
  hasSecondaryDropdown,
  id,
  yearSelected,
}) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState({});
  const [selectedYear, setSelectedYear] = useState(yearSelected || null);
  const [filteredData, setFilteredData] = useState([]);
  // const [electionType, setElectionType] = useState(null);
  const userName = localStorage.getItem("UserRole");
  const navigate = useNavigate();
  console.log(
    primaryDropdownValue,
    "primaryDropdownValue",
    primaryDropdownLabel,
    title
  );

  const electionType = title === "Assembly Details" ? "AC" : "PC";
  const fetchElectionData = async () => {
    setLoading(true);

    try {
      const response = await dataService.getPastElectionDetails(
        id,
        selectedYear,
        electionType
      );
      const electionDetails =
        response?.data?.electionDetails?.length > 0
          ? response.data.electionDetails[0]
          : [];

      const { year, typeOfElection, majority, turnout, winBy } = response.data;

      setTableData(electionDetails);
      setAdditionalInfo({
        year,
        typeOfElection,
        majority,
        turnout,
        winBy,
      });
    } catch (e) {
      console.error(e);
      // message.error("Error fetching election data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (primaryDropdownValue && selectedYear) {
      fetchElectionData();
    }
  }, [primaryDropdownValue, selectedYear]);

  const columns = [
    { title: "Party", dataIndex: "Party", key: "Party" },
    { title: "Candidate", dataIndex: "Candidate", key: "Candidate" },
    { title: "Votes", dataIndex: "Votes", key: "Votes" },
    {
      title: "%",
      dataIndex: "%",
      key: "%",
      render: (value, record) => {
        if (!record["%"] && record.message) return null; // Hide when no data found
        return value ? parseFloat(value).toFixed(2) : null;
      },
    },
    {
      title: "±%",
      dataIndex: "±%",
      key: "±%",
      render: (value, record) => {
        if (!record["±%"] && record.message) return null; // Hide when no data found
        return value ? parseFloat(value).toFixed(2) : null;
      },
    }
  ];

  const handleViewBriefDetails = () => {
    console.log(userName, "userName");
    const dropDownToSearch =
      userName == "ASSEMBLY" ? primaryDropdownData : secondaryDropdownData;
    const dropDownValue =
      userName == "ASSEMBLY" ? primaryDropdownValue : secondaryDropdownValue;
    console.log(dropDownToSearch, dropDownValue);
    const selectedItem = dropDownToSearch?.find(
      (item) => item._id === primaryDropdownValue
    );
    const data = {
      selectedAssembly: dropDownValue,
      year: selectedYear,
      electionType: electionType,
      assemblyName: selectedItem ? selectedItem.assemblyName : "",
    };

    navigate("/login/all-level-brief-details", { state: {data:data, yearSelected: selectedYear,
      firstDropDown: primaryDropdownValue,
      secondDropDown: secondaryDropdownValue,} });
  };

  const handleViewAllBoothAnalysis = async () => {
    try {
      const res = await dataService.getAssemblyAnalysisAc(
        primaryDropdownValue,
        selectedYear,
        null,
        null
      );
      if (res.code === 200) {
        const yearKey = Object.keys(res.data)[0]; // Extract the dynamic key (e.g., "2024")
        navigate("/login/all-level-election-page", {
          state: {
            electionDetails: res.data[yearKey],
            yearSelected: selectedYear,
            firstDropDown: primaryDropdownValue,
            secondDropDown: secondaryDropdownValue,
          }, // Pass the data dynamically
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    const filtered = tableData.filter((item) =>
      Object.keys(item).some(
        (key) => item[key] && item[key].toString().toLowerCase().includes(value)
      )
    );

    if (filtered.length === 0) {
      setFilteredData([{ message: "No data found" }]); // Display a message row
    } else {
      setFilteredData(filtered);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Card with Filters */}
      <Card style={{ padding: "20px", borderRadius: "10px", width: "100%" }}>
        <h3 style={{ marginBottom: "16px" }}>{title}</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Select
              placeholder={primaryDropdownLabel}
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 7,
              }}
              value={primaryDropdownValue}
              onChange={onPrimarySelect}
              loading={loading}
            >
              {primaryDropdownData.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.constituencyName
                    ? item.constituencyName
                    : item.assemblyName}
                </Option>
              ))}
            </Select>
          </Col>

          {hasSecondaryDropdown && (
            <Col xs={24} sm={12} md={8}>
              <Select
                placeholder={secondaryDropdownLabel}
                style={{
                  width: "100%",
                  border: "1px solid grey",
                  borderRadius: 7,
                }}
                value={secondaryDropdownValue}
                onChange={onSecondarySelect}
                loading={loading}
              >
                {secondaryDropdownData.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.assemblyName}
                  </Option>
                ))}
              </Select>
            </Col>
          )}

          <Col xs={24} sm={12} md={8}>
            <Select
              placeholder="Select Year"
              style={{
                width: "100%",
                border: "1px solid grey",
                borderRadius: 7,
              }}
              value={selectedYear}
              onChange={(value) => setSelectedYear(value)}
            >
              {[2024, 2019, 2014].map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      </Card>

      {/* Loading Spinner */}
      {loading ? (
        <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
      ) : (
        <div style={{ marginTop: "20px" }}>
          {/* View Brief Details Button - Always Visible when Year is Selected */}
          {selectedYear && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <Button type="primary" onClick={handleViewAllBoothAnalysis}>
                View All Booth Analysis
              </Button>

              <Button type="primary" onClick={handleViewBriefDetails}>
                View Brief Details
              </Button>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px",
            }}
          >
            <Input.Search
              placeholder="Search by Name"
              onChange={handleSearch}
              style={{ width: 200 }}
              allowClear
            />
          </div>
          {/* Table Section */}

          <Card
            style={{
              padding: "10px",
              borderRadius: "10px",
              width: "100%",
              maxWidth: "100%",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                maxHeight: "100vh",
                overflowX: "hidden",
                zIndex: "-100",
              }}
            >
              <CustomTable
                columns={columns}
                dataSource={filteredData.length > 0 ? filteredData : tableData}
                rowKey={(record, index) => index}
                pagination={true}
                bordered
                locale={{ emptyText: "No Data Found" }}
                style={{
                  width: "100%",
                  tableLayout: "fixed",
                  maxHeight: "100vh",
                  overflowX: "hidden",
                  zIndex: "-100",
                }}
              />
            </div>
          </Card>
          {/* Election Summary Section */}
          {tableData.length > 0 && (
            <Card
              style={{
                padding: "20px",
                borderRadius: "10px",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <h3>Election Summary</h3>
              <Row>
                <Col xs={24} sm={12} md={6}>
                  <p>
                    <b>Year:</b> {additionalInfo.year}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <p>
                    <b>Type of Election:</b> {additionalInfo.typeOfElection}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <p>
                    <b>Majority:</b> {additionalInfo.majority}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <p>
                    <b>Turnout:</b> {additionalInfo.turnout}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <p>
                    <b>Winning Party:</b> {additionalInfo.winBy}
                  </p>
                </Col>
              </Row>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}

export default BriefDetails;
